// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"576":"f85ac66f","776":"dbab650d"}[chunkId] + ".chunk.css";
};